import _ from 'lodash';

import { ProgramFilterType, SearchFilterConfigurationStatus } from 'constants/programs';
import { getConditionalObject } from 'utils/data';
import { getDesiredTargetFilterValue, getInvestorIdsFilterValue } from 'utils/programs';

import { getLoanInfoForLoanOptions } from '../../Content.utils';

const createMemoizedLoanInfoGetter = getLoanInfoForLoanOptions => {
  const ref = { current: null };

  return params => {
    const newLoanInfo = getLoanInfoForLoanOptions(params);

    if (_.isEqual(ref.current, newLoanInfo)) {
      return ref.current;
    }

    ref.current = newLoanInfo;

    return newLoanInfo;
  };
};

export const getMemoizedLoanInfo = createMemoizedLoanInfoGetter(getLoanInfoForLoanOptions);

export const getSearchFilterRequest = ({
  searchFilter,
  isLazyLoadEnabled,
  isOptionsDeduplicateEnabled,
}) => ({
  ..._.omit(searchFilter, [
    ProgramFilterType.DESIRED_TARGET_TYPE,
    ProgramFilterType.DESIRED_TARGET_VALUE,
  ]),
  lockTerm: _.get(searchFilter, [ProgramFilterType.LOCK_TERM, 0]),
  ...getConditionalObject(isOptionsDeduplicateEnabled, () => ({
    investorIds: getInvestorIdsFilterValue(_.get(searchFilter, ProgramFilterType.INVESTOR)),
  })),
  ...getConditionalObject(isLazyLoadEnabled, () => getDesiredTargetFilterValue(searchFilter)),
});

// Only the latest request may set the status, so a slower earlier response cannot prefill stale values.
export const trackSearchFilterConfigurationRequest = ({ request, requestIdRef, setStatus }) => {
  const requestId = requestIdRef.current + 1;

  requestIdRef.current = requestId;
  setStatus(SearchFilterConfigurationStatus.LOADING);

  const setLatestStatus = status => {
    if (requestIdRef.current === requestId) {
      setStatus(status);
    }
  };

  return request
    .then(() => setLatestStatus(SearchFilterConfigurationStatus.LOADED))
    .catch(() => setLatestStatus(SearchFilterConfigurationStatus.FAILED));
};

export const getShouldShowNoProgramsPopup = ({
  loanProgramsOptions,
  hasIneligibleOptions,
  isWithInfoTitle,
  isBestPricingSearch,
}) =>
  !loanProgramsOptions.length && !hasIneligibleOptions && !isWithInfoTitle && !isBestPricingSearch;
